export default class Masthead {

	constructor(element) {
		this.handleWindowResize = this.handleWindowResize.bind(this);
		this.element = element;
	}

	init() {
		window.addEventListener('resize', this.handleWindowResize);
		this.setCorrection();
	}

	destroy() {
		window.removeEventListener('resize', this.handleWindowResize);
	}

	handleWindowResize() {
		this.setCorrection();
	}

	setCorrection() {
		const adminBarHeight = this.getAdminBarHeight();
		const page = document.getElementById('page');
		const drawer = document.getElementById('drawer');
		const agendaMenu = document.getElementById('agenda-menu');
		const eventInfoMenu = document.getElementById('event-info-menu');
		const personInfoProfile = document.getElementById('person-info-profile');
		const searchPopper = document.getElementById('search-popper');
		const height = this.getHeight();
		if (this.element instanceof HTMLElement) {
			this.element.style.top = `${adminBarHeight}px`;
		}
		if (page instanceof HTMLElement) {
			page.style.paddingTop = `${height}px`;
		}
		if (drawer instanceof HTMLElement) {
			drawer.style.top = `${adminBarHeight}px`;
			drawer.style.height = `calc(100% - ${adminBarHeight}px)`;
			drawer.style.paddingTop = `${height}px`;
		}
		if (agendaMenu instanceof HTMLElement) {
			agendaMenu.style.top = `${adminBarHeight + height}px`;
			agendaMenu.style.maxHeight = `calc(100vh - ${adminBarHeight + height}px)`;
		}
		if (eventInfoMenu instanceof HTMLElement) {
			eventInfoMenu.style.top = `${adminBarHeight + height}px`;
			eventInfoMenu.style.maxHeight = `calc(100vh - ${adminBarHeight + height}px)`;
		}
		if (personInfoProfile instanceof HTMLElement) {
			personInfoProfile.style.top = `${adminBarHeight + height}px`;
			personInfoProfile.style.maxHeight = `calc(100vh - ${adminBarHeight + height}px)`;
		}
		if (searchPopper instanceof HTMLElement) {
			searchPopper.style.maxHeight = `calc(100% - ${adminBarHeight + height + 20}px)`;
		}
	}

	getHeight() {
		return (this.element instanceof HTMLElement) ? this.element.clientHeight : 0;
	}

	getAdminBarHeight() {
		const adminBar = document.getElementById('wpadminbar');
		return adminBar ? adminBar.clientHeight : 0;
	}
}
